import { Navigate, Outlet, useLocation, useParams } from "react-router";
import { useAuth } from "../authentication/useAuth";
import { useEffect } from "react";
import { PrivateRouteParams } from "../../pages/invite/models";
import PrivateLayout from "../layout/PrivateLayout";

const AuthOutlet = () => {
  const { authenticated, user, onChangeCustomer, customerIsChanging } =
    useAuth();
  const location = useLocation();

  const params = useParams<PrivateRouteParams>();

  useEffect(() => {
    if (
      authenticated &&
      !customerIsChanging &&
      user?.customerId &&
      params.customerId &&
      params.customerId !== user.customerId
    ) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      onChangeCustomer(params.customerId);
    }
  }, [params, user, onChangeCustomer, customerIsChanging, authenticated]);

  if (authenticated && !user?.customerId) {
    return <Navigate to="/account-select" replace />;
  }

  if (!authenticated) {
    return (
      <Navigate
        to={params?.tenantCode ? `/${params.tenantCode}` : "/"}
        replace
        state={{ from: location, originalParams: params }}
      />
    );
  }

  return (
    <PrivateLayout>
      <Outlet />
    </PrivateLayout>
  );
};

export default AuthOutlet;
